<template>
  <modal
    name="unavailable-ingredients-modal"
    :scrollable="true"
    :max-width="1000"
    width="35%"
    height="auto"
    @before-close="beforeClose">
    <error-modal-template
      :error-message="message"
      @button-clicked="$modal.hide('unavailable-ingredients-modal');"/>
  </modal>
</template>

<script>
import errorModalTemplate from './error-modal-template.vue';

export default {
  components: { errorModalTemplate },
  name: 'UnavailableIngredientsModal',
  data() {
    return {
      message: 'Alguno de los ingredientes que estás cotizando, no lo tenemos disponible.',
    };
  },
  methods: {
    beforeClose() {
      window.location.href = '/';
    },
  },
};
</script>
